// Polyfills para módulos Node.js
import { Buffer } from 'buffer';
window.Buffer = Buffer;

// Polyfill para process
if (typeof process === 'undefined') {
    window.process = {
        env: { NODE_ENV: 'development' },
        browser: true,
        version: '',
        nextTick: (cb) => setTimeout(cb, 0)
    };
}

// Polyfill para global
if (typeof global === 'undefined') {
    window.global = window;
}

// Polyfill para next-tick
if (typeof nextTick === 'undefined') {
    window.nextTick = (cb) => setTimeout(cb, 0);
} 